import { render, staticRenderFns } from "./selectPageTutorial.vue?vue&type=template&id=7ebd4829&"
import script from "./selectPageTutorial.vue?vue&type=script&lang=ts&"
export * from "./selectPageTutorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports